import React, { useMemo, useState } from "react";
import styles from "./_WorkflowTipoTarefaCor.less";
import PropTypes from "prop-types";
import { CirclePicker } from "react-color";
import { Button, Dropdown } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { HexColorPicker } from "react-colorful";
import debounce from "lodash/debounce";

const colors = ["#009EDB", "#00E8E8", "#00E8A9", "#81BE1C", "#E8E800", "#E8A900", "#543B23", "#E80000", "#E800E8", "#9E00E8"];

export default function WorkflowTipoTarefaCor(props) {
  const { cor, onSubmit } = props;
  const [edicao, setEdicao] = useState(false);
  const [open, setOpen] = useState(false);

  const fireSubmit = (cor) => {
    let promise = Promise.resolve();
    if (typeof onSubmit === "function") promise = promise.then(() => onSubmit(cor));
    return promise;
  };

  const handleClick = (e) => {
    e.preventDefault();
    setEdicao(true);
  };

  const handleChange = (e) => {
    fireSubmit(e.hex.slice(1)).then(() => setEdicao(false));
  };

  const debouncedUpdate = useMemo(() => debounce((hex) => handleChange({ hex }), 200), []);

  if (edicao) {
    return (
      <div className={styles["workflow-tipo-tarefa-cor-edicao"]}>
        <CirclePicker
          color={"#" + cor}
          colors={colors}
          onChangeComplete={(color) => {
            handleChange(color);
            setEdicao(false);
          }}
          width="unset"
          className={styles["circle-picker"]}
        />
        <Dropdown
          open={open}
          onOpenChange={(isOpen) => {
            if (!isOpen) setEdicao(false);
          }}
          trigger={["click"]}
          dropdownRender={() => (
            <div onMouseDown={(e) => e.stopPropagation()}>
              <HexColorPicker color={"#" + cor} onChange={(value) => debouncedUpdate(value)} />
            </div>
          )}
        >
          <Button icon={<PlusOutlined />} shape="circle" size="middle" className={styles["btn-nova-cor"]} onClick={() => setOpen((prev) => !prev)} />
        </Dropdown>
      </div>
    );
  }

  return (
    <div className={styles["workflow-tipo-tarefa-cor"]} onClick={handleClick}>
      <div style={{ backgroundColor: "#" + cor }} />
    </div>
  );
}

WorkflowTipoTarefaCor.propTypes = {
  cor: PropTypes.string,
  onSubmit: PropTypes.func,
};
